export function getShortExecutedCustomFieldName(field: string) {
  return field.replace('formattedData.executedCustomFields.', '')
}
